import { Stack, Typography, Button, useTheme } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const Confirm = ({ confirm }: { confirm: () => void }) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();

  return (
    <Stack
      sx={{
        justifyContent: "center",
        height: "100%",
        margin: "0 auto",
        gap: 2,
        alignItems: "center",
      }}
    >
      <Stack sx={{ gap: 1, alignItems: "center" }}>
        <Typography variant="h5" fontWeight={theme.typography.fontWeightBold}>
          {t("areYouSureWantToDeployThisPlanToProduction")}
        </Typography>
      </Stack>
      <Button variant="contained" onClick={confirm}>
        {t("confirm")}
      </Button>
    </Stack>
  );
};
